import { useEffect, useMemo, useRef } from 'react';
import { buildAccessTokenProvider } from '@app/api/token';
import { useAuthSession } from '@app/context/auth-session';
import { createAuthFetch } from '@app/utils/auth-fetch';

export const useAuthFetch = () => {
  const { refreshTokens } = useAuthSession();
  const accessTokenResolver = useMemo(() => buildAccessTokenProvider(), []);
  const refreshTokensRef = useRef(refreshTokens);

  useEffect(() => {
    refreshTokensRef.current = refreshTokens;
  }, [refreshTokens]);

  return useMemo(
    () =>
      createAuthFetch({
        resolveAccessToken: accessTokenResolver,
        refreshTokens: () => refreshTokensRef.current()
      }),
    [accessTokenResolver]
  );
};
